import {FLEETINVITE} from '../actiontype'
import request from '@/utils/request'
import {fleetInviteApi} from '@/api'
import inlineSign from '@/utils/inlinesign'
export const fleetinviteAction = () => {
  const action = (data) => (
    {
      type: FLEETINVITE,
      data
    }
  )
  return async (dispatch) => {
    let data = await request.get(fleetInviteApi,{},{
        ...inlineSign
    })
    if(data.data.data){
        dispatch(action(data.data.data))
    }
  }
}